
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#939393","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.657 14.775l-8.916 8.892a1.133 1.133 0 01-1.605 0l-4.794-4.782a1.175 1.175 0 010-1.658l8.914-8.894a1.133 1.133 0 011.606 0l4.796 4.784a1.175 1.175 0 010 1.658zM16 14l-4-4-8 8 4 4 8-8zm18.257 8.667l-8.914-8.892a1.175 1.175 0 010-1.658l4.795-4.784a1.133 1.133 0 011.605 0l8.914 8.892a1.175 1.175 0 010 1.658l-4.795 4.784a1.133 1.133 0 01-1.605 0zM39 17l-8-8-4 4 8 8 4-4zm-9.488 13.999c-.145.404-.38.784-.703 1.108l-4.144 4.144a5 5 0 01-7.071 0l-6.451-6.452a3 3 0 01-.88-2.12V24.95a1 1 0 00-.21-.615l-1.885-2.418 7.168-7.168 2.971 1.72a3 3 0 01.619.475l.038.038 5.457-.193a1 1 0 00.672-.292l2.204-2.205 1.415 1.414-2.205 2.205a3 3 0 01-2.015.877l-3.595.127.978.978-4.898 4.898.702.701a.992.992 0 001.403 0l3.678-3.677 6.049 6.049c.154.154.289.322.403.499l.812-.889a1 1 0 00.262-.675l-.05-2.708a3 3 0 01.879-2.121l1.678-1.678 1.414 1.414-1.678 1.678a1 1 0 00-.293.707l.05 2.708a3 3 0 01-.786 2.025L29.512 31zM11.63 23.107a3 3 0 01.634 1.844v2.727a1 1 0 00.293.707l6.451 6.452a3 3 0 004.243 0l4.143-4.144a1 1 0 000-1.414l-4.634-4.635-2.264 2.264a2.992 2.992 0 01-4.231 0l-.702-.702a2 2 0 010-2.828l3.484-3.484-1.535-1.535a1 1 0 00-.207-.159l-1.641-.95-4.832 4.832.798 1.025z"}})])
          )
        }
      }
    